module.exports = __webpack_public_path__ + "static/media/Week 6 Sunday Dessert.897116d9.png";